<template>
  <div>
    <v-autocomplete
      @keydown.enter="handleInput"
      :menu-props="{ maxHeight: '400' }"
      :items="users"
      :loading="loading"
      :color="color"
      :hide-no-data="true"
      :hide-selected="true"
      :outlined="outlined"
      :dense="dense"
      :label="`Digite o ${row} do usuário`"
      persistent-hint
      v-model="users"
      item-text="name"
      append-icon="search"
    >
      <template v-slot:item="{ item }">
        <v-btn
          small
          color="primary"
          elevation="2"
          @click="userSelected(item.id)"
          >{{ item.id }}</v-btn
        >
        <v-list-item @click="userSelected(item.id)">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{
              item.clientUser_client_name
            }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.cpf }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
    <v-radio-group v-model="row" row style="margin: 0px;">
      <v-radio label="nome" value="nome"></v-radio>
      <v-radio label="cpf" value="cpf"></v-radio>
      <v-radio label="e-mail" value="email"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import UserController from '../../controllers/UserController';

export default {
  data() {
    return {
      userController: new UserController(this.$resource),
      column: null,
      row: 'nome',
      texto: '',
      filters: {
        name: '',
        cpf: '',
        email: '',
        phone: '',
        status: '1',
        approved: '1',
      },
      users: this.user,
      selectUser: null,
      time: null,
      loading: false,
      color: '',
    };
  },

  props: {
    outlined: {
      type: Boolean,
      required: true,
    },
    dense: {
      type: Boolean,
      required: true,
    },
    user: {
      require: true
    }
  },

  methods: {
    handleInput(event) {
      this.color = 'primary';
      this.time = null;
      this.texto = event.target.value;
      this.loading = true;

      this.time = setTimeout(() => {
        this.validatexto();
      }, 5000);
    },

    validatexto() {
      if (this.row == 'nome') {
        this.filters.name = this.texto;
        if (this.texto.length >= 5) {
          return this.getUsers();
        } else {
          this.$awn.alert('Digite ao menos 5 caracteres para nome');
          this.color = 'red';
        }
      } else if (this.row == 'cpf') {
        this.filters.cpf = this.texto;

        if (this.texto.length == 11) {
          return this.getUsers();
        } else {
          this.$awn.alert('Digite 11 caracteres para cpf');
          this.color = 'red';
        }
      } else {
        this.filters.email = this.texto;
        if (this.validarEmail(this.texto)) {
          return this.getUsers();
        } else {
          this.$awn.alert('O texto digitado não é um e-mail');
          this.color = 'red';
        }
      }

      this.loading = false;
    },

    validarEmail(email) {
      const regex = /^\S+@\S+\.\S+$/;
      return regex.test(email);
    },

    async getUsers() {
      try {
        this.loading = true;
        let res = await this.userController.getAllUsers(1, this.filters);
        this.users = res.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        console.log(this.users);
      }
    },

    userSelected(id) {
      let selectedUser = this.users.find(user => user.id === id);
      this.users = selectedUser;
      this.$emit('selectUser', selectedUser);
    },
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  margin-bottom: 8px;
  font-size: 12px;
}

v-list-item-title {
  font-size: 7px !important;
}

v-list-item-subtitle {
  font-size: 5px !important;
}
</style>
